import { Card, Grid, Layout } from '@enterprise-ui/canvas-ui-react'

import { SectionHeader } from '../globalComponents/SectionHeader'
export const LayoutSimple = () => {
  return (
    <>
      <SectionHeader pageHeading="Welcome" />
      <Layout.Body data-testid="homePage" includeRail>
        <Card>
          <div className="hc-pa-dense">
            <Grid.Container>
              <Grid.Item>
                <p>Welcome to AP Reporting</p>
              </Grid.Item>
            </Grid.Container>
          </div>
        </Card>
      </Layout.Body>
    </>
  )
}
